module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"tyre-labels":{"header":"EU-dækskilt"}},"de":{"version":1,"tyre-labels":{"header":"EU-Reifenlabel"}},"fr":{"tyre-labels":{"header":"Étiquetage européen des pneus"}},"nl":{"tyre-labels":{"header":"EU-bandenlabel"}}}')
  delete Component.options._Ctor
}
